import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Link } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const NoPermissionInfo: React.FC = () => {
  const { t } = useTranslation();

  const handleContactUsClick = () => {
    const contactUsUrl = import.meta.env.VITE_CONTACT_US_URL;
    console.log("Contact Us URL:", contactUsUrl);
    if (contactUsUrl) {
      window.open(contactUsUrl, "_blank", "noopener,noreferrer");
    } else {
      console.error("VITE_CONTACT_US_URL is not defined");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "300px",
        textAlign: "center",
        padding: 4,
      }}
    >
      <InfoOutlinedIcon
        sx={{
          fontSize: 80,
          color: "warning.main",
          mb: 2,
        }}
      />
      <Typography variant="h5" className="font-weight-bold mb-3">
        {t("noPermissionTitle", "No Permission Associated")}
      </Typography>
      <Typography variant="body1" className="mb-2" sx={{ maxWidth: 600 }}>
        {t(
          "noPermissionMessage",
          "You do not have permission to view this page. If you believe this is an error, please contact your administrator or reach out to us for assistance.",
        )}
      </Typography>
      <Typography variant="body1" className="mt-2">
        <Link
          className="font-weight-bold green-link"
          onClick={handleContactUsClick}
          sx={{ fontWeight: "bold", color: "primary.main", cursor: "pointer" }}
        >
          {t("contactUs", "Contact Us")} &gt;
        </Link>
      </Typography>
    </Box>
  );
};

export default NoPermissionInfo;
